import styled from 'styled-components'

export default styled.h3`
  font-size: 24px;
  font-weight: 600;
  line-height: 54px;
`
